export default {
  created() {
    const metaInfo = this.$route?.meta.title;
    this.routeMetaTitle = metaInfo;
    this.routeName = this.$route?.name;
  },
};
